/**
 * Rebuilds a page marked `data: { rebuildOnIdChange: true }` when the entity id in its route changes, and otherwise
 * reuses
 * routes the way Angular does by default. The marked entity forms load their entity once in ngOnInit, so a reused page
 * would
 * keep showing the old entity.
 */

import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, BaseRouteReuseStrategy } from '@angular/router';

@Injectable()
export class EntityRouteReuseStrategy extends BaseRouteReuseStrategy {
    override shouldReuseRoute(future: ActivatedRouteSnapshot, current: ActivatedRouteSnapshot): boolean {
        if (!super.shouldReuseRoute(future, current)) {
            return false;
        }
        return (
            !future.routeConfig?.data?.['rebuildOnIdChange'] || future.paramMap.get('id') === current.paramMap.get('id')
        );
    }
}
